export default "__VITE_ASSET__DEbQsev8__"